(function($) {

  $('.search-dropdown-toggler').on('click', function(e) {
    e.preventDefault();
    const dropId = $(this).data('target') || $(this).attr('href');

    if (dropId.length > 0) {
      $(dropId).toggleClass('show');
      $(dropId).find('input').focus();
    }
    
  });
  
})(jQuery)